"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.object.entries");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _operationsConfig = require("@/api/community/operationsConfig");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'CouponSquareSettings',
  data: function data() {
    return {
      form: {
        base: {
          consumeAmount: 25,
          timeoutHours: 23
        },
        rules: {
          square: '',
          official: ''
        },
        assist: {
          hotWords: '85折, 免单, 买一赠一',
          shareText: '',
          shareImages: []
        }
      },
      dialogVisible: false,
      dialogImageUrl: '',
      shareImagePath: '' // 分享图相对路径
      ,
      memberCols: [{
        label: '游客卡',
        prop: 'visitor'
      }, {
        label: 'LV1会员',
        prop: 'lv1'
      }, {
        label: 'LV2会员',
        prop: 'lv2'
      }, {
        label: 'LV3会员',
        prop: 'lv3'
      }, {
        label: 'LV4会员',
        prop: 'lv4'
      }, {
        label: 'LV5会员',
        prop: 'lv5'
      }, {
        label: 'KOC',
        prop: 'koc'
      }, {
        label: 'KOL',
        prop: 'kol'
      }],
      limitTables: {
        dailySendNormal: [{
          label: '每日次数',
          visitor: 0,
          lv1: 1,
          lv2: 4,
          lv3: 4,
          lv4: 4,
          lv5: 4,
          koc: 0,
          kol: 0
        }],
        monthlySendNormal: [{
          label: '每月次数',
          visitor: 0,
          lv1: 1,
          lv2: 4,
          lv3: 4,
          lv4: 4,
          lv5: 4,
          koc: 0,
          kol: 0
        }],
        dailyReceivePerUser: [{
          label: '单用户日次数',
          visitor: 1,
          lv1: 1,
          lv2: 4,
          lv3: 4,
          lv4: 4,
          lv5: 4,
          koc: 0,
          kol: 0
        }],
        dailyReceiveTotal: [{
          label: '每日总次数',
          visitor: 1,
          lv1: 1,
          lv2: 4,
          lv3: 4,
          lv4: 4,
          lv5: 4,
          koc: 0,
          kol: 0
        }],
        dailyReceiveOfficial: [{
          label: '官方券日次数',
          visitor: 1,
          lv1: 1,
          lv2: 4,
          lv3: 4,
          lv4: 4,
          lv5: 4,
          koc: 0,
          kol: 0
        }]
      }
    };
  },
  created: function created() {
    this.loadConfig();
  },
  methods: {
    loadConfig: function loadConfig() {
      var _this = this;
      (0, _operationsConfig.getConfigById)(1006).then(function (res) {
        if (res.data && res.data.value) {
          try {
            var config = JSON.parse(res.data.value);
            if (config.form) {
              // 处理分享图路径 - 用相对路径展示完整URL
              if (config.form.assist && config.form.assist.shareImages && config.form.assist.shareImages.length) {
                _this.shareImagePath = config.form.assist.shareImages[0].path || '';
                config.form.assist.shareImages = [{
                  url: (0, _operationsConfig.getImageUrl)(_this.shareImagePath),
                  name: 'share.jpg'
                }];
              }
              Object.assign(_this.form, config.form);
            }
            if (config.limitTables) Object.assign(_this.limitTables, config.limitTables);
          } catch (e) {/* 忽略 */}
        }
      });
    },
    onReset: function onReset() {
      this.$refs.opsForm.resetFields();
      this.form.assist.shareImages = [];
      this.shareImagePath = '';
    },
    onSubmit: function onSubmit() {
      // ===== 1. 合并JSON写入1006（前端回显用） =====
      var payload = {
        form: _objectSpread(_objectSpread({}, this.form), {}, {
          assist: _objectSpread(_objectSpread({}, this.form.assist), {}, {
            shareImages: this.shareImagePath ? [{
              path: this.shareImagePath
            }] : []
          })
        }),
        limitTables: this.limitTables
      };
      (0, _operationsConfig.updateConfig)(1006, JSON.stringify(payload));

      // ===== 2. 与PHP一致，分别写入各独立ID（Java业务逻辑读取用） =====

      // Vue前端的key → Java的userRank值（不加*10）
      var rankMap = {
        visitor: '0',
        lv1: '1',
        lv2: '2',
        lv3: '3',
        lv4: '4',
        lv5: '5',
        koc: '6',
        kol: '7'
      };
      // 把limitTable的一行转成 {"0":0,"1":1,"2":4,...} 格式
      var rowToJson = function rowToJson(row) {
        var obj = {};
        for (var _i = 0, _Object$entries = Object.entries(row); _i < _Object$entries.length; _i++) {
          var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            val = _Object$entries$_i[1];
          if (key === 'label') continue;
          var numKey = rankMap[key];
          if (numKey !== undefined) obj[numKey] = val;
        }
        return obj;
      };

      // limitTables → 独立ID映射
      var limitIdMap = {
        dailySendNormal: 1011,
        // 每日发券限制
        monthlySendNormal: 1010,
        // 每月发券限制
        dailyReceivePerUser: 1016,
        // 单用户每日领取限制
        dailyReceiveTotal: 1015,
        // 每日领取总限制
        dailyReceiveOfficial: 1012 // 官方券每日领取限制
      };
      for (var _i2 = 0, _Object$entries2 = Object.entries(limitIdMap); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = (0, _slicedToArray2.default)(_Object$entries2[_i2], 2),
          tableName = _Object$entries2$_i[0],
          configId = _Object$entries2$_i[1];
        var row = this.limitTables[tableName][0];
        if (row) (0, _operationsConfig.updateConfig)(configId, JSON.stringify(rowToJson(row)));
      }

      // 消费金额标准 → 1013（纯数字字符串）
      (0, _operationsConfig.updateConfig)(1013, String(this.form.base.consumeAmount));

      // 搜索热词 → 1009（JSON: {"hot_word":"85折,免单"}）
      (0, _operationsConfig.updateConfig)(1009, JSON.stringify({
        hot_word: this.form.assist.hotWords
      }));

      // 分享图/词 → 1008（JSON: {"share_title":"...","share_image":"..."}）
      (0, _operationsConfig.updateConfig)(1008, JSON.stringify({
        share_title: this.form.assist.shareText,
        share_image: this.shareImagePath || ''
      }));
      this.$message.success('已保存券广场设置');
      this.loadConfig();
    },
    onExceed: function onExceed() {
      this.$message.warning('仅可上传一张图片');
    },
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleShareRemove: function handleShareRemove(file, fileList) {
      this.form.assist.shareImages = fileList;
      this.shareImagePath = '';
    },
    handleShareChange: function handleShareChange(file, fileList) {
      var _this2 = this;
      if (file && file.raw) {
        (0, _operationsConfig.uploadImage)(file.raw, '/').then(function (res) {
          _this2.shareImagePath = res.data;
          file.url = (0, _operationsConfig.getImageUrl)(res.data);
          _this2.form.assist.shareImages = [file];
        });
      }
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.indexOf('image/') === 0;
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
        return false;
      }
      return true;
    }
  }
};